<template>
    <b-row no-gutters>
        <b-col cols="12">
            <b-input-group>
                <b-form-select
                    v-bind="$attrs"
                    v-on="$listeners"
                    :options="contact_options"
                    :value="value"
                >
                    <template #first>
                        <b-form-select-option :value="null" disabled>
                            <slot />
                        </b-form-select-option>
                    </template>
                </b-form-select>

                <b-input-group-append>
                    <b-button
                        :disabled="!value"
                        variant="outline-info"
                        @click="showContact"
                        v-b-tooltip.hover
                        title="Display Contact Details"
                    >
                        <b-icon icon="display" aria-label="Help"></b-icon>
                    </b-button>
                    <b-button
                        :disabled="!customer_id || $attrs.disabled"
                        variant="outline-warning"
                        @click="openNewContact"
                        v-b-tooltip.hover
                        title="Create New Contact"
                    >
                        <b-icon icon="plus-circle" aria-label="Help"></b-icon>
                    </b-button>
                </b-input-group-append>
            </b-input-group>
        </b-col>

        <b-col cols="12">
            <customer-users
                v-show="false"
                ref="customerContactRef"
            ></customer-users>
        </b-col>
    </b-row>
</template>
<script>
import CustomerUsers from '@/components/CustomerUsers.vue'
export default {
    name: 'ContactSelection',
    components: { CustomerUsers },
    props: {
        value: {
            type: Number,
            default: 0,
        },
        customer_id: {
            type: Number,
            default: 0,
        },
    },

    computed: {
        customer_contacts() {
            return this.$store.getters['customers/customerUsers']
        },
        contact_options() {
            const contacts = this.customer_contacts
            console.log('contact selection --contacts', contacts)
            return contacts.map(x => ({
                value: x.id,
                text: x.first_name + ' ' + x.last_name,
            }))
        },
    },

    mounted() {
        console.log('$attrs', this.$attrs)
    },

    methods: {
        showContact() {
            const { value: customer_contact_id, customer_contacts } = this
            const contact = customer_contacts.find(
                x => x.id == customer_contact_id
            )
            console.log({ customer_contact_id, customer_contacts, contact })
            this.$refs.customerContactRef.viewCustomer(contact)
        },

        openNewContact() {
            this.$refs.customerContactRef.viewCustomer()
        },
    },
}
</script>
